import { lazy } from "react";
import Department from "./Department/Department";
import AddDepartment from "./Department/AddDepartment";
import Company from "./Company/Company";
import AddCompany from "./Company/AddCompany";
import UserRegistration from "./UserRegistration/UserRegistration";
import Roles from "./Roles/Roles";
import AddRoles from "./Roles/AddRoles";
import EditCompany from "./Company/EditCompany";
import ViewDepartment from "./Department/ViewDepartment";
import ViewCompany from "./Company/ViewCompany";
import ViewRoles from "./Roles/ViewRoles";
import EditEmployeeFormA from "./Employee/EditEmployeeFormA";
import DownloadEmployeeFormA from "./Employee/DownloadEmployeeFormA";
import ViewEmployeeFormAHistory from "./Employee/ViewEmployeeFormAHistory";
import EditContractorFormA from "./ContractorPerson/EditContractorFormA";
import DownloadContractorFormA from "./ContractorPerson/DownloadContractorFormA";
import ViewContractorFormAHistory from "./ContractorPerson/ViewContractorFormAHistory";
import EmployeeMedicalForm from "./Employee/EmployeeMedicalForm";
import EmployeeTrainingForm from "./Employee/EmployeeTrainingForm";
import EmployeeLocationForm from "./Employee/EmployeeLocationForm";
import EmployeeEmploymentForm from "./Employee/EmployeeEmploymentForm";
import EditEmployee from "./Employee/EditEmployee";
import ContractorPersonEmploymentForm from "./ContractorPerson/ContractorPersonEmploymentForm";
import ContractorPersonLocationForm from "./ContractorPerson/ContractorPersonLocationForm";
import ContractorPersonMedicalForm from "./ContractorPerson/ContractorPersonMedicalForm";
import ContractorPersonTrainingForm from "./ContractorPerson/ContractorPersonTrainingForm";
import EditContractorPerson from "./ContractorPerson/EditContractorPerson";

const EmployeeList = lazy(() => import("./Employee/EmployeeList"));
const AddEmployee = lazy(() => import("./Employee/AddEmployee"));
const ViewEmployee = lazy(() => import("./Employee/ViewEmployee"));

const ContractorList = lazy(() => import("./Contractor/ContractorList"));
const AddContractor = lazy(() => import("./Contractor/AddContractor"));
const ViewContractor = lazy(() => import("./Contractor/ViewContractor"));

const ContractorPersonList = lazy(() =>
  import("./ContractorPerson/ContractorPersonList")
);
const AddContractorPerson = lazy(() => import("./ContractorPerson/AddContractorPerson"));
const ViewContractorPerson = lazy(() =>
  import("./ContractorPerson/ViewContractorPerson")
);

const UserManagementRoutes = [
  /******* Department *******/
  {
    path: "/user-management/department/add",
    component: AddDepartment,
    permission: ["superAdmin"],
    nav: 1,
  },
  {
    path: "/user-management/department/edit/:dpId",
    component: AddDepartment,
    permission: ["superAdmin"],
    nav: 1,
  },
  {
    path: "/user-management/department/view/:id",
    component: ViewDepartment,
    permission: ["superAdmin"],
    nav: 1,
  },
  {
    path: "/user-management/department",
    component: Department,
    permission: ["superAdmin"],
    nav: 1,
  },

  /******* Company *******/
  {
    path: "/user-management/company/add",
    component: AddCompany,
    permission: ["superAdmin"],
    nav: 1,
  },
  {
    path: "/user-management/company/edit/:id",
    component: EditCompany,
    permission: ["superAdmin"],
    nav: 1,
  },
  {
    path: "/user-management/company/view/:id",
    component: ViewCompany,
    permission: ["superAdmin"],
    nav: 1,
  },
  {
    path: "/user-management/company",
    component: Company,
    permission: ["superAdmin"],
    nav: 1,
  },

  /******* Roles *******/
  {
    path: "/user-management/roles/add",
    component: AddRoles,
    permission: ["superAdmin"],
    nav: 1,
  },
  {
    path: "/user-management/roles/edit/:id",
    component: AddRoles,
    permission: ["superAdmin"],
    nav: 1,
  },
  {
    path: "/user-management/roles/view/:id",
    component: ViewRoles,
    permission: ["superAdmin"],
    nav: 1,
  },
  {
    path: "/user-management/roles",
    component: Roles,
    permission: ["superAdmin"],
    nav: 1,
  },

  /******* User Registration *******/
  {
    path: "/user-management/user-registration",
    component: UserRegistration,
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    nav: 1,
  },
  {
    path: "/user-management/employee/edit/:id",
    permission: ["superAdmin", "globalAdmin"],
    component: EditEmployee,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/employee/employment/:id",
    permission: ["superAdmin", "globalAdmin"],
    component: EmployeeEmploymentForm,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/employee/location/:id",
    permission: ["superAdmin", "globalAdmin"],
    component: EmployeeLocationForm,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/employee/training/:id",
    permission: ["superAdmin", "globalAdmin"],
    component: EmployeeTrainingForm,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/employee/medical/:id",
    permission: ["superAdmin", "globalAdmin"],
    component: EmployeeMedicalForm,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/employee/edit-form-a/:id",
    permission: ["superAdmin", "globalAdmin", "Form A Editor"],
    component: EditEmployeeFormA,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/employee/download-form-a/:id",
    permission: [
      "superAdmin",
      "globalAdmin",
      "projectAdmin",
      "Form A Editor",
      "Form A Viewer",
    ],
    component: DownloadEmployeeFormA,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/employee/form-a-history/:id",
    permission: ["superAdmin", "globalAdmin", "Form A Editor", "Form A Viewer"],
    component: ViewEmployeeFormAHistory,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/employee/view/:id",
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    component: ViewEmployee,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/employee/add",
    permission: ["superAdmin", "globalAdmin"],
    component: AddEmployee,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/employee",
    component: EmployeeList,
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor/edit/:id",
    permission: ["superAdmin", "globalAdmin"],
    component: AddContractor,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor/view/:id",
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    component: ViewContractor,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor/add",
    permission: ["superAdmin", "globalAdmin"],
    component: AddContractor,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor",
    component: ContractorList,
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    nav: 1,
    exact: true,
  },

  {
    path: "/user-management/contractor-person/edit/:id",
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    component: EditContractorPerson,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor-person/edit-form-a/:id",
    permission: ["superAdmin", "globalAdmin", "Form A Editor"],
    component: EditContractorFormA,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor-person/download-form-a/:id",
    permission: ["superAdmin", "globalAdmin", "Form A Editor", "Form A Viewer"],
    component: DownloadContractorFormA,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor-person/form-a-history/:id",
    permission: ["superAdmin", "globalAdmin", "Form A Editor", "Form A Viewer"],
    component: ViewContractorFormAHistory,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor-person/view/:id",
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    component: ViewContractorPerson,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor-person/add",
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    component: AddContractorPerson,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor-person/employment/:id",
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    component: ContractorPersonEmploymentForm,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor-person/location/:id",
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    component: ContractorPersonLocationForm,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor-person/training/:id",
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    component: ContractorPersonTrainingForm,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor-person/medical/:id",
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    component: ContractorPersonMedicalForm,
    nav: 1,
    exact: true,
  },
  {
    path: "/user-management/contractor-person",
    permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    component: ContractorPersonList,
    nav: 1,
    exact: true,
  },
];

export default UserManagementRoutes;
